import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

import { STATUS } from "../constants/status";
const StatusDropDown = ({ selectedStatus, handleStatusChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="status-select-label">상태</InputLabel>
      <Select
        labelId="status-select-label"
        value={selectedStatus}
        label="상태 선택"
        onChange={handleStatusChange}
      >
        {Object.keys(STATUS).map((status) => (
          <MenuItem key={status} value={status}>
            {STATUS[status]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusDropDown;
